<div fxLayout="row" fxLayoutAlign="space-between center">
  <h2>Keys</h2>
  <button mat-icon-button [routerLink]="['create']" matTooltip="Create New Key">
    <mat-icon>add</mat-icon>
  </button>
</div>

<table mat-table [dataSource]="keys" class="mat-elevation-z8">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>Key ID</th>
    <td mat-cell *matCellDef="let key">{{ key.id }}</td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>Description</th>
    <td mat-cell *matCellDef="let key">{{ key.description }}</td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef>Type</th>
    <td mat-cell *matCellDef="let key">{{ key.type }}</td>
  </ng-container>

  <ng-container matColumnDef="createdAt">
    <th mat-header-cell *matHeaderCellDef>Created At</th>
    <td mat-cell *matCellDef="let key">{{ key.createdAt | date }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let key">
      <button mat-icon-button [routerLink]="[key.id]">
        <mat-icon>visibility</mat-icon>
      </button>
      <button mat-icon-button [routerLink]="[key.id, 'edit']">
        <mat-icon>edit</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
